<template>
  <div>
     <Jumbotron
      :view="pageData[view].name"
      :momentFormat="pageData[view].jumboDateFormat"
      :salesData="dataJSON"
      :currentTimePeriod="pageData[view].name"
      :previousTimePeriod="pageData[view].previous"
    />
    <section
      class="col-12 bg-faded border-y-secondary py-6 py-lg-spacer mt-spacer"
    >
      <div class="row">
        <div class="col-12">
          <Tabs v-if="dataJSON">
            <Tab
              v-for="(countryData, countryName, index) in dataJSON[pageData[view].name]"
              :key="countryName"
              :name="countryName"
              :selected="index === 0 ? true : false"
            >
              <DataTable
                :timePeriod="pageData[view].name"
                :tableTimePeriod="pageData[view].tableTimePeriod"
                :tableData="countryData"
                :momentFormat="pageData[view].tableDateFormat"
              >
              </DataTable>
            </Tab>
          </Tabs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { eventBus } from "./../main.js";
import Jumbotron from "../components/jumbotron.vue";
import Tabs from "./../components/tabs.vue";
import Tab from "./../components/tab.vue";
import DataTable from "./../components/dataTable.vue";

import data from "../data";

export default {
  props: ["pageData"],
  components: {
    Jumbotron,
    Tabs,
    Tab,
    DataTable
  },
  data() {
    return {
      dataURL: null,
      dataJSON: data[0],
      view: null
    }
  },
  methods: {
    addToUrl(changeUrl) {
      if (window.location.href.indexOf(changeUrl) > -1) {
        return
      } else {
        this.$router.push(changeUrl);
      }
    },
    getData() {
      this.$http(this.URL)
        .then(resp => (this.dataJSON = resp.data[0]))
    }
  },
  beforeMount() {
    // this.getData();
    let data = [];

    for (let item in this.pageData) {
      data.push(item);
    }

    if (data.includes(this.$route.params.id)) {
      this.view = this.$route.params.id
    } else {
      this.view = "daily"
    }

    this.addToUrl(this.view)
  },
  created() {
    eventBus.$on(
      "viewChanged",
      (view) => {
        this.view = view;
        this.addToUrl(view);
      }
    );
  }
};
</script>
